import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {repeat} from 'lit/directives/repeat.js';
import store from '../../store';

import {} from '../../slices/productDataSlice';

@customElement('llmf-table')
export class LlmfTable extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: block;
		  padding-bottom: var(--specsheet-medium-gap);
	  }

	  table {
		border-collapse: collapse;
		width: 100%;
	  }

	  th {
		font: var(--font-specsheet-bold);
		text-align: left;
	  }

	  td {
		font: var(--font-specsheet-light);
		padding: 0 10px;
	  }

	  @media print {
		th {
		  font: var(--font-specsheet-print-bold);
		}

		td {
		  font: var(--font-specsheet-print-light);
		}

	  }
	`
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.llmf = state.productData.llmf;
	}


	render() {
		return html`

			${when(this.llmf !== null, () => html`
				<table>
					<tr>
						<th>
							<trans-label key="LE_OperatingTimeLED" context="D"></trans-label>
						</th>
						${repeat(this.llmf.llmftable, (item) => (
								html`
									<td>${item.ophours}</td>`
						))}
					</tr>
					<tr>
						<th>
							<trans-label key="LE_Lumenmaintenance" context="D"></trans-label>
						</th>
						${repeat(this.llmf.llmftable, (item) => (
								html`
									<td>${item.factor * 100}%</td>`
						))}
					</tr>
					<tr>
						<th>
							<trans-label key="LE_LLMF" context="D"></trans-label>
							*
						</th>
						${repeat(this.llmf.llmftable, (item) => (
								html`
									<td>${item.factor}</td>`
						))}
					</tr>
				</table>
			`)}

		`;
	}
}
